module.exports = __webpack_public_path__ + "static/media/incomemax-logo.35412ae9.svg";